import { render } from "./CovidTestResults.vue?vue&type=template&id=183b70f4"
import script from "./CovidTestResults.vue?vue&type=script&lang=js"
export * from "./CovidTestResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__